<template>
  <div class="apio-pill-switch">
    <div :class="[{ 'apio-pill-switch--left-on': switchStatus}, { 'apio-pill-switch--left' : !switchStatus }]" @click="toggleOn"><slot name="left" /></div>
    <div :class="[{ 'apio-pill-switch--right-on': !switchStatus }, { 'apio-pill-switch--right' : switchStatus }]"  @click="toggleOff"><slot name="right" /></div>
  </div>
</template>

<script>
export default {
  props: {
    on: {
      default: false,
    }
  },
  data() {
    return {
      switchStatus: this.on
    };
  },
  methods: {
    toggleOn() {
      if(!this.switchStatus) { this.switchStatus = true; }
      this.$emit('toggleOn')
    },
    toggleOff() {
      if(this.switchStatus) { this.switchStatus = false; }
      this.$emit('toggleOff')
    }
  },
};
</script>

<style lang="scss" scoped>
.apio-pill-switch {
  display: flex;
  border-radius: 24px;
  height: 48px;
  font-size: var(--font-paragraph-1-size);

  &--left {
    cursor: pointer;
    padding: 13px 16px;
    border: 1px solid white;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    width: fit-content;
    background: white;
    color: var(apio-blue-black);
  }

  &--left-on {
    padding: 13px 16px;
    border: 1px solid var(--apio-purple);
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    width: fit-content;
    background: var(--apio-purple);
    color: white;
    font-weight: var(--font-extra-bold);
  }

  &--right {
    cursor: pointer;
    padding: 13px 16px;
    border: 1px solid var(--apio-white);
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    width: fit-content;
    background: var(--apio-purple);
    color: var(--apio-blue-black);
    width: fit-content;
    background: white;
  }

  &--right-on {
    padding: 13px 16px;
    border: 1px solid var(--apio-purple);
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    width: fit-content;
    background: var(--apio-purple);
    color: white;
    width: fit-content;
    font-weight: var(--font-extra-bold);
  }
}
</style>